import { Card, Layout } from "antd";
import useBreakpoint from "antd/es/grid/hooks/useBreakpoint";

export function Footer() {
  const { Footer: AntdFooter } = Layout;
  const screen = useBreakpoint();
  const cardBodyOverride = !screen.sm ? "p-1!" : "";

  return (
    <AntdFooter className={"relative text-center"}>
      <div className={"pb-1 sm:pb-4 duration-300"}>
        <Card
          classNames={{
            body: cardBodyOverride,
          }}
        >
          © {new Date().getFullYear()} Equilibrium-Gaming
          <span className="block sm:inline text-xs opacity-80 sm:ml-2">v{__APP_VERSION__}</span>
        </Card>
      </div>
    </AntdFooter>
  );
}
